import axios from 'axios';

// Resolve the API base URL with a safe default.
//
// Emergent deployments serve frontend and backend under the SAME domain
// (preview, production, custom domain). A relative '/api' base therefore
// always hits the right backend regardless of which host the user opens
// (laizyleads.de, *.emergent.host, *.preview.emergentagent.com).
//
// We intentionally do NOT use REACT_APP_BACKEND_URL here:
//   - it gets baked into the JS bundle at build time and is impossible to
//     change without a re-deploy
//   - it has caused production outages when set to a stale hostname
//   - relative paths are immune to all of that
//
// If you ever need to point the SPA at a backend on a different origin
// (e.g. local dev with FE on :3000 and BE on :8001 without proxy),
// uncomment the override block below.
const API_BASE = '/api';
// const API_BASE = process.env.REACT_APP_BACKEND_URL
//   ? `${process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '')}/api`
//   : '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
